import React, { FC } from 'react'
import s from './Heading2.module.scss'

const Heading2: FC = ({ children }) => {
  return <h2 className={s.root}>{children}</h2>
}

export default Heading2
